export default __webpack_public_path__ + "logo_tdc.7fbad5b.svg";